import { Controller } from "@hotwired/stimulus"

// Floating "Back to top" pill (attached to the pill element itself).
// Stays hidden while the user is actively scrolling, then appears once
// scrolling pauses beyond the threshold. Hides again on the next scroll
// or when the user is back near the top.
export default class extends Controller {
  static values = {
    idleDelay: { type: Number, default: 750 },
    thresholdScreens: { type: Number, default: 1.5 }
  }

  connect() {
    this.boundOnScroll = this.onScroll.bind(this)
    window.addEventListener("scroll", this.boundOnScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.boundOnScroll)
    clearTimeout(this.idleTimer)
  }

  onScroll() {
    this.hide()
    clearTimeout(this.idleTimer)
    this.idleTimer = setTimeout(() => {
      if (window.scrollY > window.innerHeight * this.thresholdScreensValue) {
        this.show()
      }
    }, this.idleDelayValue)
  }

  scrollToTop() {
    this.hide()
    clearTimeout(this.idleTimer)
    window.scrollTo({ top: 0, behavior: "smooth" })
  }

  show() {
    this.element.classList.remove("opacity-0", "-translate-y-3", "pointer-events-none")
  }

  hide() {
    this.element.classList.add("opacity-0", "-translate-y-3", "pointer-events-none")
  }
}
